// extracted by mini-css-extract-plugin
export default {"title":"storedWishlist_title__GSnWC","goBack":"storedWishlist_goBack__GlTyC"};